<template>
  <LoginLayout class="insert">
    <h1 class="title">本登録完了</h1>
    <p class="text">本登録ありがとうございます。<br />下記のIDで本登録が完了しました。</p>
    <p class="address">{{ mailAddress }}</p>
    <div class="operation">
      <p>
        台帳の操作説明をオンラインで実施します。<br />
        ご予約はこちらからお願いします。
      </p>
      <Button :small="this.isSP" primary @click="onClose">オンライン説明予約</Button>
    </div>
    <template #link>
      <router-link :to="{ name: isSP ? 'SP/login' : 'Login' }">ログイン画面へ</router-link>
    </template>
  </LoginLayout>
</template>

<script>
import { mapState } from 'vuex'
import LoginLayout from '@/components/templates/LoginLayout'
import Button from '@/components/atoms/Button'

export default {
  name: 'Insert',
  components: {
    LoginLayout,
    Button,
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      mailAddress: state => state.login.account.mailAddress,
    }),
  },
  methods: {
    onClose() {
      window.location.href =
        'https://docs.google.com/forms/d/e/1FAIpQLSfxLwakO_4i2LhKFotcmqROS6JLN6Vwlc4NP5W4NOZ9uyOpHg/viewform'
    },
  },
}
</script>

<style lang="postcss" scoped>
.title {
  font-size: 21px;
  font-weight: bold;
  text-align: center;
}

.text {
  margin-top: 44px;
}

.address {
  font-weight: bold;
  margin-top: 24px;
}

.operation {
  background: var(--very-light-blue-1);
  font-weight: 600;
  margin-top: 86px;
  padding: 32px;
  text-align: center;
}

.button {
  margin-top: 24px;
}

.responsive {
  @media screen and (max-width: 559px) {
    .title {
      font-size: 16px;
    }

    .text {
      margin-top: 40px;
    }

    .operation {
      margin: 40px -16px 0 -16px;
      padding: 32px 16px;
    }

    .button {
      margin-top: 24px;
    }
  }
}
</style>
